<template lang="html">
  <div id="reschedulingSenderConfirmation">
    <h1 class="header">授業振替依頼をする</h1>
    <section class="section">
      <h1 class="section-description">以下の内容で授業振替依頼を行います</h1>
      <h1 class="section-description">よろしければ「振替依頼をする」ボタンを押してください</h1>
      <!--振替を希望する授業の情報-->
      <div class="info">
        <h1 class="info-caption">振替を希望する授業</h1>
        <div class="info-content">
          <div>
            <lable
              v-if="receiverInfo.user_type === 'student'"
              key="student-name"
            >
              生徒のお名前：{{receiverInfo.fullname}}様
            </lable>
            <label
              v-if="receiverInfo.user_type === 'teacher'"
              key="teacher-name"
            >
              先生のお名前：{{receiverInfo.fullname}}先生
            </label>
          </div>
          <div>
            <label>日付　　　　：{{formattedDate(reschedulingInfo.targetReservation.date)}}</label>
          </div>
          <div>
            <label>時間　　　　：{{reschedulingInfo.targetReservation.startTime}} 〜 {{reschedulingInfo.targetReservation.endTime}}</label>
          </div>
        </div>
      </div>
      <!--振替を希望する授業の情報 終わり-->
      <!--候補日時の情報-->
      <div class="info">
        <h1 class="info-caption">振替候補日時</h1>
        <div class="info-content">
          <ul id="candidate-list">
            <li
              v-for="(candidate, index) in reschedulingInfo.candidateDatetimes"
              :key="'candidate' + index"
            >
              <div class="candidate-caption">
                <i class="el-icon-caret-right"/>
                <label>候補{{index+1}}</label>
              </div>
              <div class="candidate-content">
                <div>
                  <label>日付：{{formattedDate(candidate.date)}}</label>
                </div>
                <div>
                  <label>時間：{{candidate.startTime}} 〜 {{candidate.endTime}}</label>
                  <label>{{candidate.mode === 'slot' ? 'の1コマ' : 'の中で' + candidate.duration + '分間' }}</label>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!--候補日時の情報 終わり-->
      <!--振替理由-->
      <div class="info">
        <h1 class="info-caption">振替希望理由</h1>
        <div class="info-content">
          <div
            v-for="row in reschedulingInfo.reason.split('\n')"
            key="reason-row"
          >
            <label>{{ row }}</label>
          </div>
        </div>
      </div>
      <!--振替理由 終わり-->
      <!--（講師のみ）授業のオプション-->
      <div
        v-if="$store.state.userInfo.user_type === 'teacher'"
        key="reservation-option"
        class="info"
      >
        <h1 class="info-caption">振替後の授業情報</h1>
        <div class="info-content">
          <div>
            <label>授業の種類　　　　　　：{{ reschedulingInfo.reservationOption.reservationType === '短期' ? '短期講座' : reschedulingInfo.reservationOption.reservationType + '授業'}}</label>
          </div>
          <div>
            <label>配布物（確認テスト等）：{{ reschedulingInfo.reservationOption.hasTest ? 'あり' : 'なし' }}</label>
          </div>
          <div>
            <label>連絡事項：</label>
            <div
              v-for="row in reschedulingInfo.reservationOption.reservationMessage.split('\n')"
              key="message-row"
              class="message-row"
            >
              <label>{{ row }}</label>
            </div>
          </div>
        </div>
      </div>
      <!--（講師のみ）授業のオプション 終わり-->
      <div>
        {{ Message }}
      </div>
      <el-button
        class="btn btn-cancel"
        @click="cancelButtonClicked()"
      >
        戻って修正する
      </el-button>
      <el-button
        class="btn btn-ok"
        @click="okButtonClicked()"
      >
        振替依頼をする
      </el-button>
    </section>
  </div>
</template>
<script>
  import moment from 'moment'
  import {
    mapActions
  } from 'vuex'

  export default {
    data () {
      return {
        reschedulingInfo: null,
        receiverInfo: {},
        ClickCheck: 0,
        Message: ''
      }
    },
    name: 'reschedulingSenderConfirmation',
    mounted () {
      this.reschedulingInfo = this.$store.state.reschedulingInfo
      let receiverId = this.reschedulingInfo.receiver
      this.getLectures({})
      .then(() => {
        for (let lecture of this.$store.state.lectureInfo) {
          if (lecture.teacher.id === receiverId) {
            this.receiverInfo = lecture.teacher
            this.receiverInfo.user_type = 'teacher'
          } else if (lecture.student.id === receiverId) {
            this.receiverInfo = lecture.student
            this.receiverInfo.user_type = 'student'
          }
        }
      })
      window.addEventListener('beforeunload', (e) => {
        e.returnValue = 'まだ振替依頼は完了していません'
        return 'まだ振替依頼は完了していません'
      })
    },
    computed: {
    },
    methods: {
      ...mapActions([
        'getLectures',
        'postReschedulings',
        'sendMailReschedulingRequest',
        'setReschedulingInfo',
        'updateReschedulingInfo',
        'sendMailReschedulingError'
      ]),
      formattedDate (date) {
        moment.lang('ja', {
          weekdaysShort: ['日', '月', '火', '水', '木', '金', '土']
        })
        return moment(date, 'YYYY-MM-DD').format('YYYY年MM月DD日（ddd）')
      },
      cancelButtonClicked () {
        this.$router.push('/SpRescheduling')
      },
      okButtonClicked () {
        if (this.ClickCheck === 0) {
          this.ClickCheck = 1
          let paramTargetReservation =
            this.reschedulingInfo.targetReservation.id
              ? {
                id: this.reschedulingInfo.targetReservation.id
              }
              : {
                date: this.reschedulingInfo.targetReservation.date,
                start_time: this.reschedulingInfo.targetReservation.startTime,
                end_time: this.reschedulingInfo.targetReservation.endTime
              }
          let paramCandidateDatetimes = this.reschedulingInfo.candidateDatetimes.map((cand) => {
            return {
              date: cand.date,
              start_time: cand.startTime,
              end_time: cand.endTime,
              mode: cand.mode,
              duration: Number(cand.duration)
            }
          })
          let paramReservationOption = {
            reservation_type: this.reschedulingInfo.reservationOption.reservationType,
            has_test: this.reschedulingInfo.reservationOption.hasTest,
            reservation_message: this.reschedulingInfo.reservationOption.reservationMessage
          }
          this.postReschedulings({
            sender: this.reschedulingInfo.sender,
            receiver: this.reschedulingInfo.receiver,
            target_reservation: paramTargetReservation,
            candidate_datetimes: paramCandidateDatetimes,
            reason: this.reschedulingInfo.reason,
            reservation_option: paramReservationOption,
            school_id: this.$store.state.userInfo.school_id
          })
          .then((res) => {
            this.reschedulingInfo.hash = res.data.hash
            this.sendMailReschedulingRequest(res.data.hash)
            .then((response) => {
              this.$store.state.reschedulingInfo = null
              this.$router.push('/SpSenderCompletion')
            })
            .catch((err) => {
              console.error(err)
              this.updateReschedulingInfo({
                hash: this.reschedulingInfo.hash,
                reservation: {
                  is_status: 'error',
                  rescheduled_reservation: this.reschedulingInfo.targetReservation.id,
                  receiver_message: this.reschedulingInfo.reason,
                  alternative_datetimes: this.reschedulingInfo.candidateDatetimes
                }
              }).then((res) => {
                // 事務局にエラー通知
                this.sendMailReschedulingError(this.reschedulingInfo.hash)
                .catch((err) => {
                  console.error(err)
                })
              }).then(() => {
                this.reschedulingInfo.status = 'error'
                this.setReschedulingInfo(this.reschedulingInfo)
                this.ClickCheck = 0
              })
            })
          })
          .catch((err) => {
            console.error(err)
            this.ClickCheck = 0
          })
        } else {
          this.Message = '処理中です。少々お待ちください。'
        }
      }
    }
  }
</script>
<style lang="css" scoped>
  #reschedulingSenderConfirmation {
    text-align: center;
    font-family: "メイリオ", "ヒラギノ丸ゴ ProN", 'sans-serif','Avenir','Helvetica Neue','Helvetica','Arial','Hiragino Sans','ヒラギノ角ゴシック',YuGothic,'Yu Gothic','メイリオ', Meiryo,'ＭＳ Ｐゴシック','MS PGothic', 'sans-serif';
    margin-bottom: 50px;
    color:#5A5A5A;
  }
  .header {
    background-color: #0065B3;
    color: white;
    text-align: center;
    font-size: 20px;
    margin: 25px auto 20px;
    max-width: 800px;
    padding: 4px;
  }
  .section {
    border-bottom: solid 2px black;
    text-align: center;
    margin: 10px 5% 10px 5%;
    padding-bottom: 20px;
  }
  .section-description {
    font-size: 16px;
    margin-bottom: 5px;
  }
  .info {
    max-width: 500px;
    margin: 20px auto;
    border: solid 1px #0065b3;
  }
  .info-caption {
    text-align: left;
    font-size: 18px;
    color: white;
    background-color: #0065b3;
    padding-left: 10px;
  }
  .info-content {
    text-align: left;
    padding: 10px 10px 10px 30px;
  }
  .candidate-caption {
    font-size: 18px;
    font-weight: bold;
    color: #0065b3;
  }
  .candidate-content {
    padding-left: 30px;
  }
  .message-row {
    margin: 0 20px;
  }
  .btn {
    color: black;
  }
  .btn-ok {
    color: white;
    background-color: #0065b3;
  }
</style>



// WEBPACK FOOTER //
// SpSenderConfirmation.vue?52c4c335